<template>
  <div>
      <DataTable :value="records" :lazy="true" :paginator="true" :rows="10" ref="dt" dataKey="id" :loading="loading"
          :totalRecords="totalRecords" @page="onPage($event)" @filter="onFilter($event)" :scrollable="true"
          scrollHeight="500px" :rowHover="true" showGridLines :class="['p-datatable--ue-trademarks']">

          <template #empty>
              No US Trademarks found.
          </template>

          <template #loading>
              Loading US Trademark data. Please wait.
          </template>

          <Column field="trademark_id" header="Trademark No."></Column>

          <Column field="name" header="Name"></Column>

          <Column field="status" header="Status">
              <template #body="{ data }">
                  {{ data.status }}
              </template>
          </Column>

          <Column field="url" header="Classes">
              <template #body="{ data }">
                  <ul class="checker-search-results__class-list">
                      <li v-for="(classItem, index) in data.classes" :key="index"
                          class="checker-search-results__class-list-item">{{ classItem }}</li>
                  </ul>
              </template>
          </Column>

          <Column field="url" header="URL">
              <template #body="{data}">
                  <a target="_blank" :href="'https://euipo.europa.eu/eSearch/#details/trademarks/' + data.trademark_id">Click here</a>
              </template>
          </Column>

      </DataTable>
      
      <template v-if="totalRecords > 0">
          <div class="creator-search-results__accordion-copy">
              {{ totalRecords }} EU Trademarks Found
          </div>
      </template>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ApiMixin from "../../mixins/apiMixin";
import { logCatNumDivs } from "./catnum.js";

const props = defineProps(['searchToken']);

const dt = ref();
const lazyParams = ref({});
const loading = ref(false);
const totalRecords = ref(0);
const records = ref(null);

let reloadInterval;

onMounted(async () => {
lazyParams.value = {
  first: 0,
  rows: dt.value.rows
};

await loadLazyData();
});

async function onPage(event) {
lazyParams.value = event;
await loadLazyData();
}

async function loadLazyData() {
  const categoryIds = logCatNumDivs();
  clearInterval(reloadInterval);
  loading.value = true;

  let result;
  // If the categoryIds is empty, don't pass it
  if (!categoryIds || categoryIds.length === 0) {
      // console.log('no category was passed');
      result = await ApiMixin.methods.euTrademarkPaginate(
      props.searchToken,
      lazyParams.value
    );
  } else {
    // console.log('category was passed');
      result = await ApiMixin.methods.euTrademarkPaginate(
      props.searchToken,
      lazyParams.value,
      categoryIds
    );
  }


  // Object.values(result.results).forEach((resultItem, index) => {
  //   console.log(`Result Item ${index}:`, resultItem);
  // });

  // EMPTY RECORD SET OR AN ERROR OCCURRED.
  if (!result) {
    records.value = [];
    totalRecords.value = 0;
    loading.value = false;
    console.log('No records found or error occurred.');
    return false;
  }

  records.value = Object.values(result.results);

  // Reload table every 5 seconds if dataset incomplete and not on the last page
  if (
    result.results.length < dt.value.rows &&
    (lazyParams.value.page + 1) < lazyParams.value.pageCount
  ) {
    reloadInterval = setInterval(() => {
      loadLazyData();
    }, 5000);
}

totalRecords.value = result.totalRecords;
loading.value = false;
}
</script>
